import { useState, useEffect } from 'react';
import { getCountryConfig } from './countries';

export const useCountryConfig = () => {
  const [config, setConfig] = useState(getCountryConfig());

  useEffect(() => {
    // Écouter les changements de pays
    const handleStorageChange = () => {
      setConfig(getCountryConfig());
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return config;
};